import jsPDF from "jspdf";
import { menu, restaurant, formulas } from "../mock";

export const downloadMenuPDF = () => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 18;
  let y = margin;

  // ---- Header band ----
  doc.setFillColor(27, 123, 113); // #1B7B71
  doc.rect(0, 0, pageW, 38, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  doc.text("BAAN MAE", pageW / 2, 18, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("RESTAURANT THAÏLANDAIS · BOUGIVAL", pageW / 2, 26, { align: "center" });
  doc.setFontSize(8);
  doc.text(restaurant.address, pageW / 2, 32, { align: "center" });

  y = 48;
  doc.setTextColor(31, 41, 55);

  // ---- Formulas ----
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(27, 123, 113);
  doc.text("NOS FORMULES", margin, y);
  y += 6;
  doc.setDrawColor(27, 123, 113);
  doc.line(margin, y, pageW - margin, y);
  y += 6;

  formulas.forEach((f) => {
    if (y > pageH - 50) { doc.addPage(); y = margin; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor(31, 41, 55);
    doc.text(f.title, margin, y);
    doc.setTextColor(27, 123, 113);
    doc.text(`${f.price} € / pers.`, pageW - margin, y, { align: "right" });
    y += 6;

    f.sections.forEach((s) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(75, 85, 99);
      doc.text(`${s.title} :`, margin + 2, y);
      y += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9.5);
      doc.setTextColor(55, 65, 81);
      s.items.forEach((it) => {
        if (y > pageH - 20) { doc.addPage(); y = margin; }
        doc.text(`•  ${it}`, margin + 6, y);
        y += 4.6;
      });
      if (s.note) {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8.5);
        doc.setTextColor(120, 120, 120);
        doc.text(s.note, margin + 6, y);
        y += 5;
      }
    });
    y += 3;
  });

  y += 4;

  // ---- Categories (à la carte) ----
  const renderDish = (dish) => {
    if (y > pageH - 22) { doc.addPage(); y = margin; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(31, 41, 55);
    const nameMaxW = pageW - margin * 2 - 25;
    const suffix = dish.signature ? "  ★" : "";
    doc.text(dish.name + suffix, margin, y, { maxWidth: nameMaxW });
    doc.text(`${dish.price} €`, pageW - margin, y, { align: "right" });
    y += 5;
    if (dish.suffix) {
      doc.setFont("helvetica", "italic");
      doc.setFontSize(8.5);
      doc.setTextColor(180, 100, 20);
      doc.text(`(${dish.suffix})`, margin, y);
      y += 4;
    }
    if (dish.desc) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(75, 85, 99);
      const lines = doc.splitTextToSize(dish.desc, pageW - margin * 2 - 18);
      doc.text(lines, margin, y);
      y += lines.length * 4.2;
    }
    y += 3;
  };

  Object.entries(menu).forEach(([category, cat]) => {
    if (y > pageH - 60) { doc.addPage(); y = margin; }

    doc.setDrawColor(27, 123, 113);
    doc.setLineWidth(0.4);
    doc.line(margin, y, pageW - margin, y);
    y += 6;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(27, 123, 113);
    doc.text(category.toUpperCase(), margin, y);
    y += 6;
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    if (cat.priceHint) {
      doc.setFont("helvetica", "italic");
      doc.setFontSize(9.5);
      doc.setTextColor(27, 123, 113);
      doc.text(cat.priceHint, margin, y);
      y += 6;
    }

    if (cat.items) {
      cat.items.forEach(renderDish);
    }

    if (cat.groups) {
      cat.groups.forEach((g) => {
        if (y > pageH - 30) { doc.addPage(); y = margin; }
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(27, 123, 113);
        doc.text(g.title, margin, y);
        y += 5;
        g.items.forEach(renderDish);
        y += 2;
      });
    }

    if (cat.note) {
      if (y > pageH - 18) { doc.addPage(); y = margin; }
      doc.setFont("helvetica", "italic");
      doc.setFontSize(9);
      doc.setTextColor(120, 120, 120);
      doc.text(`✦ ${cat.note}`, margin, y);
      y += 5;
    }

    y += 4;
  });

  // ---- Footer on last page ----
  const addFooter = () => {
    const totalPages = doc.internal.getNumberOfPages();
    for (let p = 1; p <= totalPages; p++) {
      doc.setPage(p);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(107, 114, 128);
      doc.text(`BAAN MAE — Bougival · 06 32 18 35 54 · lchainoy27@gmail.com`, pageW / 2, pageH - 8, { align: "center" });
      doc.text(`${p} / ${totalPages}`, pageW - margin, pageH - 8, { align: "right" });
    }
  };
  addFooter();

  doc.save("Menu-Baan-Mae.pdf");
};
